module.exports = __webpack_public_path__ + "static/media/mv06.138826ad.jpg";